var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            top: "50px",
            title: `命中配置查询`,
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { padding: "0 50px" },
              attrs: {
                model: _vm.formChild,
                "label-width": "120px",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "配置类型", prop: "appType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formChild.appType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formChild, "appType", $$v)
                        },
                        expression: "formChild.appType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("渠道"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formChild.appType == 1
                ? _c(
                    "el-form-item",
                    {
                      attrs: { prop: "appidFilterNames", label: "渠道(appID)" },
                    },
                    [
                      _c("DynamicOption", {
                        staticStyle: { width: "200px" },
                        attrs: { singleSelect: true },
                        model: {
                          value: _vm.formChild.appid,
                          callback: function ($$v) {
                            _vm.$set(_vm.formChild, "appid", $$v)
                          },
                          expression: "formChild.appid",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "终端类型", prop: "terminalType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formChild.terminalType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formChild, "terminalType", $$v)
                        },
                        expression: "formChild.terminalType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("发送端"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("接收端"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "定制类型", prop: "customizedType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formChild.customizedType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formChild, "customizedType", $$v)
                        },
                        expression: "formChild.customizedType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("SDK"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("APP"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "厂商", prop: "facturer" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.facturer,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "facturer", $$v)
                      },
                      expression: "formChild.facturer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "型号", prop: "model" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.model,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "model", $$v)
                      },
                      expression: "formChild.model",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "uid", prop: "uid" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "uid", $$v)
                      },
                      expression: "formChild.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户ID（uuid）", prop: "uuid" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.uuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "uuid", $$v)
                      },
                      expression: "formChild.uuid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "应用版本", prop: "appVer" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.appVer,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "appVer", $$v)
                      },
                      expression: "formChild.appVer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "SDK版本", prop: "sdkVer" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.sdkVer,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "sdkVer", $$v)
                      },
                      expression: "formChild.sdkVer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "系统版本", prop: "osVer" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.osVer,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "osVer", $$v)
                      },
                      expression: "formChild.osVer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "解码器", prop: "codec" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formChild.codec,
                      callback: function ($$v) {
                        _vm.$set(_vm.formChild, "codec", $$v)
                      },
                      expression: "formChild.codec",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("input", false)
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.configCommonSave },
                },
                [_vm._v("发起查询")]
              ),
            ],
            1
          ),
          _c("el-input", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { type: "textarea", rows: 15, placeholder: "响应结果" },
            model: {
              value: _vm.formChild.value,
              callback: function ($$v) {
                _vm.$set(_vm.formChild, "value", $$v)
              },
              expression: "formChild.value",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }